import { render, staticRenderFns } from "./paramForm.vue?vue&type=template&id=f32164c2&scoped=true&"
import script from "./paramForm.vue?vue&type=script&lang=js&"
export * from "./paramForm.vue?vue&type=script&lang=js&"
import style0 from "./paramForm.vue?vue&type=style&index=0&id=f32164c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32164c2",
  null
  
)

export default component.exports